import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import "flag-icons/css/flag-icons.min.css";

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
